@let events = (lastEquipmentEventsService.events$ | async) ?? [];
@let isEventsLoading = lastEquipmentEventsService.loadingStatus() === LoadingState.LOADING;
@let isEventsLoaded = lastEquipmentEventsService.loadingStatus() === LoadingState.READY;

<section class="panel last-events">
  <header class="last-events__header">
    <h2 class="last-events__header-title">{{ 'monitoring.dashboard.events.title' | translate }}</h2>
    <lib-button
      class="last-events__header-button"
      buttonStyle="transparent-tertiary"
      [routerLink]="'/notifications'"
      >{{ 'monitoring.dashboard.events.see-all-btn' | translate }}
    </lib-button>
  </header>

  <lib-table
    class="last-events__table"
    [columns]="columns"
    [dataSource]="events"
    [cellTemplates]="{
      model,
      worker,
      ipAddress,
      description,
      date,
    }"
    [loaded]="isEventsLoaded"
    [loading]="isEventsLoading"
  />

  <ng-template
    #model
    let-data="data"
  >
    <div class="last-events__table-cell">
      {{ asEquipmentEvent(data).modelName }}
    </div>
  </ng-template>

  <ng-template
    #worker
    let-data="data"
  >
    <div
      class="last-events__table-cell"
      [class.last-events__table-cell--unknown]="asEquipmentEvent(data).isUnknownWorker"
    >
      {{ asEquipmentEvent(data).workerName }}
    </div>
  </ng-template>

  <ng-template
    #ipAddress
    let-data="data"
  >
    <div class="last-events__table-cell">
      {{ asEquipmentEvent(data).ipAddress }}
    </div>
  </ng-template>

  <ng-template
    #description
    let-data="data"
  >
    <div [class]="'last-events__table-cell ' + getSeverityClass(asEquipmentEvent(data).severity)">
      {{ getEventDescription(asEquipmentEvent(data)) }}
    </div>
  </ng-template>

  <ng-template
    #date
    let-data="data"
  >
    <div class="last-events__table-cell">
      <div>{{ asEquipmentEvent(data).createdDate | date: 'yyyy.MM.dd' : 'UTC' }}</div>
      <div class="last-events__time">
        {{ asEquipmentEvent(data).createdDate | date: 'HH:mm:ss' : 'UTC' }} (UTC)
      </div>
    </div>
  </ng-template>
</section>
